import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { environment } from '@environments/environment';
import { LocationModel, ResellerModel, UserModel } from '@models/index';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppFacadeService } from '@services/app-facade.service';
import { LocationsFacadeService } from '@services/locations/locations-facade.service';
import { ResellersFacadeService } from '@services/resellers/resellers-facade.service';
import { ReviewsFacadeService } from '@services/reviews/reviews-facade.service';
import { UsersService } from '@services/users/users.service';
import { NEVER, Subscription } from 'rxjs';
import { hideIntercom, showIntercom, showIntercomChat } from '@utilities/function-utils';


@Component({
  selector: 'upgrade-feature-modal',
  templateUrl: './upgrade-feature-modal.component.html',
  styleUrls: ['./upgrade-feature-modal.component.sass']
})
export class UpgradeFeatureModalComponent implements OnInit, OnDestroy {
  @Input() title: string;
  @Input() bodyText: string;
  @Input() bodyTextLink: string;
  @Output() addOnEmit = new EventEmitter();
  @Output() upgradePlanEmit = new EventEmitter();
  @Output() cancelEmit = new EventEmitter();
  userLogged: UserModel
  location: LocationModel;
  reseller: ResellerModel;
  _subs: Subscription = NEVER.subscribe()
  loggedUser: UserModel;


  constructor(
    public activeModal: NgbActiveModal,
    private reviewsFacadeService: ReviewsFacadeService,
    private locationsFacadeService: LocationsFacadeService,
    private resellerService: ResellersFacadeService,
    private appFacadeService: AppFacadeService,
  ) {

  }

  ngOnInit(): void {
    this._subs.add(
      this.locationsFacadeService
        .getCurrentLocation$()
        .subscribe(item => this.location = item)
    )

    this._subs.add(
      this.resellerService.
        getSelectedReseller$()
        .subscribe(item => this.reseller = item)
    )
    this._subs.add(
      this.appFacadeService
        .getLoggedUser$()
        .subscribe(user => this.userLogged = user)
    )
    this._subs.add(
      this.appFacadeService.getLoggedUser$()
        .subscribe(user => {
          this.loggedUser = user;
        })
    )
  }
  addOn() {
    this.addOnEmit.emit("addOn");
    this.activeModal.dismiss();
  }
  upgradePlan() {
    this.upgradePlanEmit.emit("upgradePlanEmit");
    this.activeModal.dismiss();
  }
  cancel() {
    this.cancelEmit.emit("cancelEmit");
    this.activeModal.dismiss();
  }
  ngOnDestroy(): void {
    if (this._subs) this._subs.unsubscribe()
  }

}
